String.prototype.toTitleCase = function () {
    var title = this,
        i,
        i2,
        word,
        wordBefore,
        wordAfter,
        wordParsed,
        titleWordLength,
        newTitle = [],
        lowerCaseWords = [
            //official AP Title Case lowercase words
            'a',
            'an',
            'and',
            'at',
            'but',
            'by',
            'for',
            'in',
            'nor',
            'of',
            'on',
            'or',
            'so',
            'the',
            'to',
            'up',
            'yet',

            //extra words
            'per',
            'via',
            'vs',

            //other languages, use with caution
            'en',
            'fur', //problematic?
            'und'
        ],

        //uppercase words are replaced with the exact case used here
        //so that plural acronyms can be set to mixed case
        upperCaseWords = [
            //acronyms to force uppercase
            //not real words, no issues

            //Countries
            'USA',
            'UK',
            //'US' //problematic

            //States
            'AL',
            'AK',
            //'AS', //problematic
            'AZ',
            'AR',
            'CA',
            'CO',
            'CT',
            'DE',
            'DC',
            'FM',
            'FL',
            'GA',
            'GU',
            //'HI', //problematic
            'ID',
            'IL',
            //'IN', //problematic
            'IA',
            'KS',
            'KY',
            'LA', //problematic?
            //'ME', //problematic
            'MH',
            'MD',
            'MA', //problematic?
            'MI',
            'MN',
            'MS',
            'MO',
            'MT',
            'NE',
            'NV',
            'NH',
            'NJ',
            'NM',
            'NY',
            'NC',
            'ND',
            'MP',
            'OH', //problematic?
            'OK',
            //'OR', //problematic
            'PW',
            'PA',
            'PR',
            'RI',
            'SC',
            'SD',
            'TN',
            'TX',
            'UT',
            'VT',
            'VI',
            'VA',
            'WA',
            'WV',
            'WI',
            'WY',

            //Geographic Directional
            'N',
            'E',
            'S',
            'W',
            'NE',
            'SE',
            'NW',
            'SW',

            //Roman Numerals 1-40
            //feel free to add more
            'I',
            'II',
            'III',
            'IV',
            'V',
            'VI',
            'VII',
            'VIII',
            'IX',
            'X',
            'XI',
            'XII',
            'XIII',
            'XIV',
            'XV',
            'XVI',
            'XVII',
            'XVIII',
            'XIX',
            'XX',
            'XXI',
            'XXII',
            'XXIII',
            'XXIV',
            'XXV',
            'XXVI',
            'XXVII',
            'XXVIII',
            'XXIX',
            'XXX',
            'XXXI',
            'XXXII',
            'XXXIII',
            'XXXIV',
            'XXXV',
            'XXXVI',
            'XXXVII',
            'XXXVIII',
            'XXXIX',
            'XL',

            //NIH and ICs
            'NIH',
            'NIAAA',
            'NIA',
            'NIAID',
            'NIADDK',
            'NIAMS',
            'NCCIH',
            'NCI',
            'CLC',
            'CIT',
            'NIDA',
            'NIDCD',
            'NIDCR',
            'NIDDK',
            'DS',
            'NIBIB',
            'NIEHS',
            'NEI',
            'NIGMS',
            //'GAS', //problematic
            'NICHD',
            'NHGRI',
            'NHLBI',
            'NLM',
            'NIMHD',
            'NIMH',
            'NB',
            'NINR',
            'NINDS',
            'ORFDO',
            'OLAO',
            'OppNet',
            'ORS',
            'ARRA',
            'CCR',
            'CSR',
            'ORIP',
            'RMOD',
            'NCRR',
            'DRS',
            'SBRP',
            'NCATS',
            'FIC',
            'WHI',
            'WETP',
            'ACF',
            'AHRQ',
            'ADAMHA',

            //CDC
            'CDC',
            'ODCDC',
            'NCIPC',
            'OID',
            'NCPDCID',
            'NCEZID',
            'NCBDD',
            'NCCDPHP',
            'NCEH',
            'EAPO',
            'OGDP',
            'CGH',
            'PHITPO',
            'NCHM',
            'OHS',
            'NCIRD',
            'LSPPPO',
            'OMHHE',
            'ONDIEH',
            'OSELS',
            'NIOSH',
            'OSTLTS',
            'OWH',
            'PHPPO',
            'OCPHP',
            'NCHHSTP',
            'SEPDPO',
            'NCHS',
            'PHSPO',
            'OPHPR',
            'ATSDR',
            'OWCD',

            'HHS',
            'ASPE',
            'ONCHIT',
            'ACL',
            'ASPR',

            'FDA',

            'HRSA',
            'BHP',

            'OASH',
            'ASC',
            'OFP',
            'OMH',
            'OAPP',

            'SAMHSA',
            'CSAP',
            'CMHS',
            'CSAT',

            'VA',
            'BLRD',
            'CSP',
            'CSRD',
            'HSRD',
            'ORD',
            'RRD',

            //other agencies
            'EPA',
            'NIST',

            'NASA',
            'JPL',
            'JWST',

            'JDRF',
            'LUNGevity',
            'PCORI',
            'PEPFAR',

            'NCID',
            'OD',
            'OS',
            'PHSPO',
            'NLM',

            //medical
            'HIV',
            'STD',
            'STDs',
            'TB',

            //Other
            'AI'

        ];

    if (title) {

        title = title.toLowerCase().split(' ');
        titleWordLength = title.length;

        for (i = 0; i < titleWordLength; i++) {

            word = title[i];
            wordBefore = '';
            wordAfter = '';
            wordParsed = false;

            if (word) {

                //check for special characters before word and remove for parsing
                if (!word.charAt(0).match(/[a-z]/i)) {
                    wordBefore = word.charAt(0);
                    word = word.slice(1);
                }

                //check for special characters after word and remove for parsing
                if (!word.slice(-1).match(/[a-z]/i)) {
                    wordAfter = word.slice(-1);
                    word = word.slice(0, -1);
                }

                //skip lowercase rule for first and last word
                if (i !== 0 || i !== titleWordLength) {
                    //Make word all lowercase

                    for (i2 = 0; i2 < lowerCaseWords.length; i2++) {
                        if (word === lowerCaseWords[i2]) {
                            wordParsed = true;
                        }
                    }
                }

                //Make word all uppercase
                if (wordParsed === false) {
                    for (i2 = 0; i2 < upperCaseWords.length; i2++) {
                        if (word === upperCaseWords[i2].toLowerCase()) {
                            word = upperCaseWords[i2];
                            wordParsed = true;
                        }
                    }
                }

                //Capitalized first letter of word
                if (wordParsed === false) {
                    word = word.charAt(0).toUpperCase() + word.slice(1);
                }

                //restore special characters before and after word
                word = wordBefore + word + wordAfter;

                newTitle.push(word);
            }

        }

        newTitle = newTitle.join(' ');

        return newTitle;
    }

};
